import { useBunker } from '@/providers/BunkerProvider';
import { gunterzBold } from '@/theme/fonts';
import { Card, Group, Text, rem } from '@mantine/core';
import styles from './Bunker.module.css';
import type { BunkerEquipCardType } from './data';
export type BunkerEquipCardProps = BunkerEquipCardType & {
  handleClick: () => void;
};
export const BunkerEquipCard: React.FC<BunkerEquipCardProps> = ({
  handleClick,
  ...props
}) => {
  const {
    selectedPart
  } = useBunker();
  return <Card h={{
    base: 52,
    sm: 56,
    lg: 60
  }} p={10} radius={5} className={styles.card} mod={{
    active: props.part === selectedPart.part
  }} onClick={handleClick}>
      <Group justify="space-between">
        <Text fz="xs" fw={700} c={props.part === selectedPart.part ? 'var(--text-grey-300)' : 'var(--text-prime)'}>
          {props.part}
        </Text>
        <Text fz="xs" tt="uppercase" fw={700} c={props.part === selectedPart.part ? 'var(--text-grey-300)' : 'var(--text-purple)'}>
          {props.rarity}
        </Text>
      </Group>
      <Text mt={4} fz={{
      base: 14,
      sm: 18
    }} lh={{
      base: rem(14),
      sm: rem(18)
    }} className={gunterzBold.className} c={props.part === selectedPart.part ? 'var(--text-grey-300)' : 'var(--text-white)'}>
        {props.equipName}
      </Text>
    </Card>;
};